import React from 'react';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons/faDoorOpen';
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil';
import { faRefresh } from '@fortawesome/free-solid-svg-icons/faRefresh';

import IdeaUpdateModal from '@buyside/components/presentation/IdeaShowPage/AuthorActions/ideaUpdateModal';
import PostTweetModal from '@buyside/components/presentation/Twitter/PostTweet/postTweetModal';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Link from '@buyside/components/presentation/Link/link';

import { adminIdea, adminUserPage, ideaEditUrl, ideaUrl } from '@buyside/util/urlHelper';

import styles from './authorActionsStyles.scss';

const AuthorActions: React.FC<{
  approved: boolean;
  ideaAuthorId?: string;
  ideaId: string;
  isAdmin: boolean;
  isAuthor: boolean;
  isIdeaOpen: boolean;
}> = ({ approved, ideaAuthorId, ideaId, isAdmin, isAuthor, isIdeaOpen }) => {
  const isUserAuthorized = isAuthor || isAdmin;
  const initialTweetMsg = `Come see my new idea at https://www.sumzero.com${ideaUrl(ideaId)}!`;
  return (
    <div className={styles.actionWrapper}>
      {isUserAuthorized && isIdeaOpen && (
        <IdeaUpdateModal
          analyticsTag="update-position-top"
          closeIdea={false}
          faIcon={faRefresh}
          ideaId={ideaId}
          modalText="Add Update"
        />
      )}
      {((isAuthor && isIdeaOpen) || isAdmin) && (
        <Button
          faIcon={faPencil}
          text="Edit Idea"
          type={BUTTON_TYPES.LINK}
          url={ideaEditUrl(ideaId)}
        />
      )}
      {isUserAuthorized && isIdeaOpen && (
        <IdeaUpdateModal
          analyticsTag="update-position"
          closeIdea
          faIcon={faDoorOpen}
          ideaId={ideaId}
          modalText="Close Idea"
        />
      )}
      {isAuthor && approved && (
        <PostTweetModal tweetPrompt="Tweet Your Idea" initialTweetMsg={initialTweetMsg} />
      )}
      {isAdmin && (
        <section className={styles.admin}>
          <Link to={adminIdea(ideaId)} target="_blank">
            View Idea in Admin
          </Link>
          {ideaAuthorId && (
            <Link to={adminUserPage(ideaAuthorId)} target="_blank">
              View Author in Admin
            </Link>
          )}
        </section>
      )}
    </div>
  );
};

export default AuthorActions;
